module.exports = __webpack_public_path__ + "img/icon-facebook.1370d760.svg";